"use client";
import { React, useState } from "react";
import { useParams } from "react-router-dom";
import BackButton from "./../components/common/BackButton";
import TopBarSignedIn from "./../components/common/TopBarSignedIn";
import PageTitle from "./../components/post/PageTitle";
import PostsTable from "./../components/post/PostsTable";
import SearchAndFilter from "./../components/post/SearchAndFilter";

import { useQuery } from "@tanstack/react-query";
import { getPostByTopicId } from "../api/postsApi";

function Post() {
  const { topicId } = useParams();
  // Fetch topics
  const { data, error, isLoading } = useQuery({
    queryKey: ["topics", topicId], // Include topicId to refetch when it changes
    queryFn: () => getPostByTopicId(topicId), // ✅ Pass function reference
  });
  const [viewMode, setViewMode] = useState("table");

  return (
    <div className="w-full bg-white min-h-screen text-primary">
      <TopBarSignedIn />
      <main className="flex flex-col gap-6 items-start p-6 mx-auto w-full max-w-[1272px] max-sm:px-4">
        <BackButton href="/app/topics" />
        <PageTitle title={data && data.title} topicId={topicId} />
        <SearchAndFilter />
        {data && <>
          <PostsTable posts={data.posts} topicId={topicId} />
        </>}
      </main>
      {/* <Footer /> */}
    </div>
  );
}


export default Post;
